import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
import { NotificationData } from '../models/ui';

type UiState = { notifications: Array<NotificationData> };

const initialState: UiState = {
  notifications: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addNotification(state, action) {
      state.notifications.push({
        id: uuid(),
        message: action.payload.message,
      });
    },
    removeNotification(state) {
      state.notifications.shift();
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
